'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { pluralize } from '@repo/utils';
export const formatPendingActionsLabel = (count: number) => pluralize(count, 'pending action');
interface PendingActionsListProps {
  count: number;
  children: ReactNode;
  'data-testid'?: string;
}
export function PendingActionsList(t0) {
  const $ = _c(10);
  const {
    count,
    children,
    "data-testid": dataTestId
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = formatPendingActionsLabel(count);
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-foreground text-sm">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <div className="gap-sm flex max-h-[400px] flex-col overflow-auto max-lg:max-h-[300px]">{children}</div>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== dataTestId || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="p-sm gap-sm flex flex-col" data-testid={dataTestId}>{t2}{t3}</div>;
    $[6] = dataTestId;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}